module.exports = __webpack_public_path__ + "img/STARMANIA_BLUES_15s.9581168b.jpg";